import { of } from "rxjs";
import { actionDisconnectedByLogin } from "./actionReconnectAfterLogin";
export var pathHandleDisconnectedByLogin = function () {
    return of(actionDisconnectedByLogin());
};



//////////////////
// WEBPACK FOOTER
// ./src/features/reconnect-after-login/pathHandleDisconnectedByLogin.ts
// module id = 1844
// module chunks = 3